document.addEventListener('DOMContentLoaded', () => {
    const urlParams = new URLSearchParams(window.location.search);
    const openAccordionId = urlParams.get('openAccordion');

    if (openAccordionId) {
        const accordionInput = document.getElementById(openAccordionId);

        if (accordionInput && accordionInput.closest('.accordion-item')) {
            accordionInput.checked = true;
            setTimeout(() => {
                const accordionTop = accordionInput.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: accordionTop - 100
                });
            }, 100);
        }
    }
});
